import React from 'react';
import SparkleIconSvg from '../../assets/svgs/sparkle.svg';
import styles from './SparkleIcon.scss';

export interface SparkleIconProps {
  size?: number;
  className?: string;
}

export function SparkleIcon({ size = 80, className }: SparkleIconProps) {
  return (
    <div className={`${styles.container} ${className || ''}`} style={{ '--size': `${size}px` } as React.CSSProperties}>
      <SparkleIconSvg className={styles.icon} />
    </div>
  );
}
